import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';
import { customerModel } from '../models/customerModel';

@Injectable({
  providedIn: 'root'
})
export class CustomerService {
  searchCustomerdata(viewModel: { DateFrom: Date; DateTo: Date; PageNo: number; PageSize: number; }) {
    throw new Error('Method not implemented.');
  }

  constructor(private _http : HttpClient) { }

  getCustomerProfile(customerId) : Observable<any>{
    //?SiteId='+SiteId
    return this._http.get<any>(environment.config.BASE_API_URL + "Customer?customerId=" + customerId);
  }

  getdata(customerModel:customerModel): Observable<any> {
    return this._http.post<any>(environment.config.BASE_API_URL + 'CustomerWiseInvoices/SearchCustomers', customerModel);
  }

  getCustomerCard(customerId) : Observable<any>{
    //?SiteId='+SiteId
    return this._http.get<any>(environment.config.BASE_API_URL + "Card/GetCustomerCards?customerId=" + customerId);
  }

  setDefaultCard(reqBody: any){
    return this._http.post<any>(environment.config.BASE_API_URL + 'Order/UpdateOrderCard', reqBody);
  }

  getCustomerTransactionDetails(req : any) : Observable<any>{
    return this._http.post<any>(environment.config.BASE_API_URL + 'CustomerWiseInvoices/PostCustomerTransactionDetails', req);
  }


}
